import React, { Component } from 'react';
import { change } from 'redux-form';
import amlogo from '../../assets/images/company-client-landing-page-auditionmagiciconplain@2x.png'

export default class Footer extends Component {

  render() {
    return (
      <div className="row footer2 large-expand">
          <div className="row register-footer2">
              <div className="column footer-logo">
                  <a href="https://www.auditionmagic.com/" target="_blank"><img width="50px" src={amlogo}/></a>
              </div>
              <div className="column">
                  Powered by <a className="a-text" href="https://www.auditionmagic.com/" target="_blank">Audition Magic</a> © 2019
              </div>
          </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/company/footer.js